import { defineFetch } from 'resift';

export default defineFetch({
  displayName: 'Get Source Mappings',
  make: (sourceId: string) => ({
    key: [sourceId],
    request: () => ({ http }) =>
      http({
        method: 'GET',
        route: '/source-mappings',
        query: { sourceId },
      }),
  }),
});
